export enum LayoutTemplateType {
    Default = 'default',
    Simple = 'simple',
  }